import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from "@angular/forms";
import { Subscription } from "rxjs";
import { PremiseRow } from "../../_model/store-response/premise-row";
import { TableFilters } from "../../_model/table-response/table-filters";
import { ClientStateService } from "../../components/navbar/client-state.service";
import { SnackbarService } from "../../service/snackbar.service";
import { StoreService } from "../../service/store.service";
import { StoreStateService } from "./store-state.service";
import { User } from "../../_model/user/user";
import { UserService } from '../../service/user.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PremiseComponent } from './premise/premise.component';
import { StoresMultipleInputFilterComponent } from '../../components/stores-multiple-input-filter/stores-multiple-input-filter.component';


@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  standalone: true,
  imports: [MatProgressSpinnerModule, PremiseComponent, StoresMultipleInputFilterComponent],
  providers: [StoreStateService],
  styleUrls: ['./store.component.scss']
})
export class StoreComponent implements OnInit, OnDestroy {

  isLoadingResults = true;
  isLoadingData = false;

  filters!: TableFilters[];
  premiseRows!: PremiseRow[] | null;;
  storeSubscription!: Subscription;
  clientSubscription!: Subscription;

  // lastFilter: FormGroup;
  selectedFilters!: FormGroup<any> | null;

  constructor(private service: StoreService,
              private sbService: SnackbarService,
              private stateService: StoreStateService,private userService: UserService,
              private clientStateService: ClientStateService) {
  }

  ngOnInit() {
    this.storeSubscription = this.stateService.storeChanged$.subscribe(storeChanged => {
      if (storeChanged) {
       if (this.selectedFilters) {
      this.onSelectedFilter(this.selectedFilters);
       }
      }
    });

    this.clientSubscription = this.clientStateService.clientStateChanged$.subscribe(() => {
      this.initializeStoreConfig();
      this.premiseRows = [];
    });
    this.selectedFilters = null;
    this.initializeStoreConfig();
  }

  // private getFilters() {
  //   this.isLoadingResults = true;
  //   this.service.getStoreConfigFilters().subscribe(response => {
  //     this.filters = response.data;
  //     this.isLoadingResults = false;
  //   });
  // }

  public initializeStoreConfig() {
    this.isLoadingResults = true;
    this.premiseRows = null;
    let user: User = this.userService.getUser();
    this.service.getStoreConfigFilters(user.brand).subscribe(response => {
        this.filters = response.data;
        this.isLoadingResults = false;
        this.isLoadingData = true;
      },
      () => this.isLoadingResults = false);
  }

  public getFilters() {
    this.isLoadingResults = true;
    if(this.selectedFilters != null){
      let user: User = this.userService.getUser();
      this.service.filterStoreConfig(this.selectedFilters,user.brand).subscribe(response => {
        this.premiseRows = response.data;
                if (!this.isPremiseRows()) {
          this.sbService.openSnackBar('Premise not found; Please check it exists in the Back Office system (noting replication time to CSI)', 'Close');
        }
        this.isLoadingResults = false;
      },
      () => this.isLoadingResults = false);
    }

  }


  onSelectedFilter(selectedFilter: FormGroup) {
    if (
      (selectedFilter.value &&
        selectedFilter.value.tableFilter &&
        selectedFilter.value.value) ||
      (selectedFilter &&
        typeof selectedFilter.value.multipleFilterarray != "undefined" &&
        selectedFilter.value.multipleFilterarray != null &&
        selectedFilter.value.multipleFilterarray.length != null &&
        selectedFilter.value.multipleFilterarray.length > 0)
    ) {
      this.selectedFilters = selectedFilter;
      sessionStorage.setItem('setFilter', JSON.stringify(selectedFilter.value));
    } else {
      this.selectedFilters = null;
      this.initializeStoreConfig();
    }
    this.getFilters();
    // this.initializeCustomerMapping();
  }

  // private getStoreConfig(property: string, value: string) {
  //   this.isLoadingResults = true;
  //   this.service.getStoreConfig(property, value).subscribe(response => {
  //       this.premiseRows = response.data;
  //       if (!this.isPremiseRows()) {
  //         this.sbService.openSnackBar('Premise not found; Please check it exists in the Back Office system (noting replication time to CSI)', 'Close');
  //       }
  //       this.isLoadingResults = false;
  //     },
  //     () => this.isLoadingResults = false);
  // }

  isPremiseRows = () => this.premiseRows && this.premiseRows.length > 0;

  ngOnDestroy(): void {
    this.storeSubscription.unsubscribe();
    this.clientSubscription.unsubscribe();
  }
}
